<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="mb-0">Start Dialysis Session</h2>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <loader v-if="pageLoading" />
      <div v-if="!pageLoading" class="modal-body">
        <!-- Patient Verification -->
        <h4>Patient Verification</h4>
        <div class="form-grid">
          <div class="form-group">
            <label>Name:</label>
            <input
              v-model="form.patient_name"
              type="text"
              readonly
              class="readonly-input"
            />
          </div>
          <div class="form-group">
            <label>Patient Number:</label>
            <input
              v-model="form.hospital_number"
              type="text"
              readonly
              class="readonly-input"
            />
          </div>
          <div class="form-group">
            <label>Ward:</label>
            <!-- <input v-model="form.ward" type="text" /> -->
            <select v-model="form.ward" :onchange="change_beds_to_wards_match">
              <option value="">Select</option>
              <option v-for="ward in all_wards" :key="ward.id" :value="ward.id">
                {{ ward.ward_name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Bed Number:</label>
            <!-- <input v-model="form.bed_number" type="text" /> -->
            <select v-model="form.bed_number">
              <!-- <option value="">Select</option> -->
              <option v-for="bed in all_beds" :value="bed.id" :key="bed.id">
                {{ bed.bed_number }}
              </option>
            </select>
          </div>
        </div>

        <!-- Medical History -->
        <h4>Medical History</h4>
        <div class="form-grid-1col">
          <div class="form-group">
            <label>Known Allergies:</label>
            <textarea v-model="form.allergies"></textarea>
          </div>
          <div class="form-group">
            <label>Current Medications:</label>
            <textarea v-model="form.medications"></textarea>
          </div>
          <div class="form-group">
            <label>Previous Dialysis Complications:</label>
            <textarea v-model="form.previous_complications"></textarea>
          </div>
        </div>

        <!-- Vital Signs -->
        <h4>Vital Signs</h4>
        <div class="form-grid">
          <div class="form-group">
            <label>Blood Pressure:</label>
            <input v-model="form.bp" type="text" placeholder="e.g 120/80" />
          </div>
          <div class="form-group">
            <label>Pulse Rate (bpm):</label>
            <input v-model="form.pulse" type="number" />
          </div>
          <div class="form-group">
            <label>Respiratory Rate (rpm):</label>
            <input v-model="form.respiratory_rate" type="number" />
          </div>
          <div class="form-group">
            <label>Temperature (°C):</label>
            <input v-model="form.temperature" type="number" step="0.1" />
          </div>
          <div class="form-group">
            <label>Weight (kg):</label>
            <input v-model="form.weight" type="number" step="0.1" />
          </div>
        </div>

        <!-- Vascular Access -->
        <h4>Vascular Access</h4>
        <div class="form-grid">
          <div class="form-group">
            <label>Access Type:</label>
            <select v-model="form.access_type">
              <option value="">Select</option>
              <option value="AV Fistula">AV Fistula</option>
              <option value="AV Graft">AV Graft</option>
              <option value="Catheter">Catheter</option>
            </select>
          </div>
          <div class="form-group">
            <label>Infection/Clot Presence:</label>
            <select v-model="form.infection_status">
              <option value="">Select</option>
              <option value="None">None</option>
              <option value="Infection">Infection</option>
              <option value="Clot">Clot</option>
            </select>
          </div>
        </div>

        <!-- Machine Setup -->
        <h4>Machine Setup</h4>
        <div class="form-grid">
          <div class="form-group">
            <label>Dialyzer Type:</label>
            <input v-model="form.dialyzer" type="text" />
          </div>
          <div class="form-group">
            <label>Dialysate Composition:</label>
            <input v-model="form.dialysate_composition" type="text" />
          </div>
          <div class="form-group">
            <label>Anticoagulant Dose (ml):</label>
            <input v-model="form.anticoagulant_dose" type="number" step="0.1" />
          </div>
        </div>
      </div>

      <div v-if="!pageLoading" class="modal-footer">
        <!-- <button type="button" class="btn-secondary" @click="closeModal">
          Cancel
        </button> -->
        <button type="button" class="btn-primary" @click="startSession">
          Start Session
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import showNotification from "../../../notification/notify";
import loader from "./loader.vue";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "StartDialysisModal",
  data() {
    return {
      form: {
        patient_name: this.patient.name,
        hospital_number: this.patient.opd,
        ward: "",
        bed_number: "",
        allergies: "",
        medications: "",
        previous_complications: "",
        bp: "",
        pulse: "",
        respiratory_rate: "",
        temperature: "",
        weight: "",
        access_type: "",
        infection_status: "",
        dialyzer: "",
        dialysate_type: "",
        dialysate_composition: "",
        anticoagulant_dose: "",
      },
      all_wards: [],
      all_beds: [],
      pageLoading: true,
    };
  },
  props: {
    visit_id: {
      type: [String, Number],
      required: true,
    },
    patient: {
      type: [Object],
      required: true,
    },
  },
  components: {
    loader,
  },
  methods: {
    closeModal() {
      this.$emit("close-start-session-modal");
    },
    async get_wards() {
      const url = "inpatient/find_wards";
      const req_body = {};
      const resp = await generalApiRequest(url, "GET", req_body, 1);
      this.all_wards = resp.data;
      this.pageLoading = false;
      // console.log(resp);
    },
    async change_beds_to_wards_match() {
      this.form.bed_number = "";
      const placeholder = [{ bed_number: "Loading...", id: "" }];
      this.all_beds = placeholder;
      const url = "inpatient/findCompanyBeds";
      const req_body = {
        beds_to_query: "all_in_a_ward_free",
        ward_id: this.form.ward,
      };
      const resp = await generalApiRequest(url, "POST", req_body, 1);
      this.all_beds = resp;
      // console.log(resp);
    },
    async allergies_medications_and_complications() {
      const url = "dialysis/allergies_medications_and_complications";
      const req_body = {
        patient_id: this.patient.id,
      };
      const resp = await generalApiRequest(url, "GET", req_body, 1);
      // console.log(resp);
      if (resp.allergies) {
        this.allergies = resp.allergies.allergies;
      }
      var complications = "";
      if (resp.complications.length > 0) {
        resp.complications.forEach((element) => {
          complications = complications + ", " + element.complication_name;
        });
        this.previous_complications = complications;
      }
    },
    async startSession() {
      this.pageLoading = true;
      const payload = {
        patient_id: this.patient.id,
        visit_id: this.visit_id,
        ward_id: this.form.ward,
        bed_id: this.form.bed_number,
        allergies: this.form.allergies,
        medications: this.form.medications,
        complications: this.form.previous_complications,
        bp: this.form.bp,
        pulse: this.form.pulse,
        respiratory_rate: this.form.respiratory_rate,
        temperature: this.form.temperature,
        weight: this.form.weight,
        access_type: this.form.access_type,
        infection_status: this.form.infection_status,
        dialyzer: this.form.dialyzer,
        dialysate_type: this.form.dialysate_type,
        dialysate_composition: this.form.dialysate_composition,
        anticoagulant_dose: this.form.anticoagulant_dose,
        completed: false,
        start_time: new Date().toISOString(),
        machine_number: "",
      };

      const url = "dialysis/start";
      const resp = await generalApiRequest(url, "POST", payload, 1);
      if (resp) {
        showNotification("Procedure Started Successfully", "success", 500);
        this.closeModal();
      } else {
        // this.closeModal();
        this.pageLoading = false;
      }
    },
  },
  mounted() {
    this.get_wards();
    this.allergies_medications_and_complications();
    // console.log(this.patient);
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 70vw;
  overflow-y: auto;
  max-height: 90vh;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  border: none;
  color: white;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  border-radius: 0.3rem;
}

h4 {
  margin-top: 1.2rem;
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.3rem;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.form-grid-1col {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 0.45rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
}

textarea {
  min-height: 60px;
  resize: vertical;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.btn-primary {
  background: #2786f7;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-secondary {
  background: #bbb;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
.readonly-input[readonly] {
  background-color: #bbb;
}
</style>
